import { createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pantry-option-axis-page" }
const _hoisted_2 = { class: "pantry-option-axis-page-area" }
const _hoisted_3 = { class: "pantry-option-axis-page-image-area" }
const _hoisted_4 = {
  ref: "image",
  class: "pantry-option-axis-page-image"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "pantry-option-axis-page-image-divider-horizontal" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "pantry-option-axis-page-image-divider-vertical" }, null, -1)
const _hoisted_7 = { class: "pantry-option-axis-page-setting-area" }
const _hoisted_8 = { class: "pantry-option-axis-page-setting-button-area" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "pantry-option-axis-page-save-button-text" }, "設定保存", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "pantry-option-axis-page-cancel-button-text" }, "キャンセル", -1)
const _hoisted_11 = { class: "pantry-optical-axis-page-dialog-area" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PantryOpticalAxisCompleteDialog = _resolveComponent("PantryOpticalAxisCompleteDialog")
  const _component_CommonDesignDialog = _resolveComponent("CommonDesignDialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("img", _hoisted_4, null, 512),
        _hoisted_5,
        _hoisted_6
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode("div", _hoisted_8, [
          _createVNode("div", {
            class: "pantry-option-axis-page-setting-button-text-left",
            style: _ctx.styleLeft,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clickLeft()))
          }, "左に回転", 4),
          _createVNode("div", {
            class: "pantry-option-axis-page-setting-button-text-right",
            style: _ctx.styleRight,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clickRight()))
          }, "右に回転", 4)
        ])
      ]),
      _createVNode("div", {
        class: "pantry-option-axis-page-save-button-area",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.clickSave()))
      }, [
        _hoisted_9
      ]),
      _createVNode("div", {
        class: "pantry-option-axis-page-cancel-button-area",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.clickCancel()))
      }, [
        _hoisted_10
      ])
    ]),
    _withDirectives(_createVNode("div", _hoisted_11, [
      _createVNode(_component_PantryOpticalAxisCompleteDialog, {
        isShowDialog: _ctx.isShowSaveCompleteDialog,
        onNegativeClick: _ctx.clickSaveComplete
      }, null, 8, ["isShowDialog", "onNegativeClick"])
    ], 512), [
      [_vShow, _ctx.isShowSaveCompleteDialog]
    ]),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: !!_ctx.handleApiError,
      dialogType: 9,
      title: _ctx.getApiErrorTitle,
      message: _ctx.getApiErrorMessage,
      negativeLabel: _ctx.ERROR_BUTTON_LABEL,
      onNegativeClick: _ctx.closeError
    }, null, 8, ["isShowDialog", "title", "message", "negativeLabel", "onNegativeClick"]),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: _ctx.isShowNoImageDialog,
      dialogType: 9,
      title: '補正対象がありません',
      message: '庫内画像が一度も撮影されていないため調整ができません。撮影してから再度お試しください。',
      negativeLabel: 'OK',
      onNegativeClick: _ctx.closeNoImageDialog
    }, null, 8, ["isShowDialog", "onNegativeClick"])
  ]))
}